import { Table, TableItem, TableRow, Tag, Typography } from '@components';
import { FormatDate } from '@utils';
import { Progress } from 'antd';
import { navigate } from 'gatsby';
import React, { FC } from 'react';
import { Eye, List } from 'react-feather';

export const UserProjects: FC = ({ projects }) => {
  const tableHeaders: object = [
    'Project',
    'Sprints',
    'Status',
    'Progress',
    'Deadline',
  ];

  const viewDetail = (projectId: number) => {
    navigate(`/project/detail/overview?projectId=${projectId}`);
  };

  return (
    <div className="h-full">
      {projects.length > 0 ? (
        <div className="border-b dark:border-gray-700">
          <Table header={tableHeaders}>
            {Object.keys(projects)
              .slice(0, 4)
              .map((key, i) => (
                <TableRow key={key}>
                  <TableItem>
                    <span className="block text-xs">
                      {projects[key].proj_number}
                    </span>
                    <span>{projects[key].proj_onderwerp}</span>
                  </TableItem>
                  <TableItem>
                    <Tag
                      label={projects[key].phases_count}
                      icon={<List size={16} />}
                      style="muted"
                    />
                  </TableItem>
                  <TableItem>
                    <Tag
                      label={projects[key].proj_status}
                      style={projects[key].proj_status}
                    />
                  </TableItem>
                  <TableItem>
                    <div className="w-4/5">
                      <Progress percent={projects[key].proj_progress} />
                    </div>
                  </TableItem>
                  <TableItem>
                    <FormatDate date={projects[key].proj_deadline} />
                  </TableItem>
                  <TableItem>
                    <button
                      onClick={() => {
                        viewDetail(projects[key].proj_id);
                      }}
                    >
                      <Eye size={18} />
                    </button>
                  </TableItem>
                </TableRow>
              ))}
          </Table>
        </div>
      ) : (
        <div className="h-full">
          <Typography type={'default'} tag={'h1'}>
            Geen projecten.
          </Typography>
        </div>
      )}
    </div>
  );
};

export default UserProjects;
